<template>
  <div class="pb-card-container">
    <div class="pb-top-container">
      <div class="pb-header-container">
        <img src="@shared/assets/img/logo/black-short-logo.png" class="logo" alt="SmartAC.com" />
        <div class="pb-header">SmartAC.com Promo Builder</div>
      </div>
      <button type="button" class="close-button" @click="togglePopup('showExitPopup', true)">
        <img src="@shared/assets/img/general/x-black.png" class="close-img" alt="Close" />
      </button>
    </div>
    <div class="pb-body-container">
      <div class="pb-section-container">
        <div class="pb-section-body-container">
          <div
            v-if="partnerSettings?.LOGO_URL"
            class="pb-logo-container"
            :style="{ backgroundColor: partnerSettings?.PRIMARY_COLOR }"
          >
            <img
              v-if="partnerSettings?.LOGO_URL"
              class="pb-logo"
              :src="partnerSettings?.LOGO_URL"
              alt="Logo"
            />
          </div>
          <OfferSummary
            :index="1"
            :active="activeStepIdx === 1"
            :changeActiveStepIdx="changeActiveStepIdx"
            :updatePromo="updatePromo"
            :finishedSection="finishedSection"
            :promo="promo"
            :toggleInfoModal="toggleInfoModal"
            :setSectionIncomplete="setSectionIncomplete"
          />
          <PromoImages
            :index="2"
            :active="activeStepIdx === 2"
            :changeActiveStepIdx="changeActiveStepIdx"
            :updatePromo="updatePromo"
            :finishedSection="finishedSection"
            :promo="promo"
            :imagePreviewOne="imagePreviewOne"
            :previewOneFile="previewOneFile"
            :changeSelectedImage="changeSelectedImage"
            :toggleInfoModal="toggleInfoModal"
            :setSectionIncomplete="setSectionIncomplete"
            :errorObj="errorObj"
          />
          <PromoDetailsImage
            :index="3"
            :active="activeStepIdx === 3"
            :changeActiveStepIdx="changeActiveStepIdx"
            :updatePromo="updatePromo"
            :finishedSection="finishedSection"
            :promo="promo"
            :imagePreviewTwo="imagePreviewTwo"
            :previewTwoFile="previewTwoFile"
            :changeSelectedImage="changeSelectedDetailImage"
            :changePreviewLabelsVisible="changePreviewLabelsVisible"
            :previewLabelsVisible="previewLabelsVisible"
            :toggleInfoModal="toggleInfoModal"
            :setSectionIncomplete="setSectionIncomplete"
            :errorObj="errorObj"
          />
          <OfferType
            :index="4"
            :active="activeStepIdx === 4"
            :changeActiveStepIdx="changeActiveStepIdx"
            :updatePromo="updatePromo"
            :partnerSettings="partnerSettings"
            :finishedSection="finishedSection"
            :promo="promo"
            :setSectionIncomplete="setSectionIncomplete"
          />
          <PromotionInfo
            :index="5"
            :active="activeStepIdx === 5"
            :changeActiveStepIdx="changeActiveStepIdx"
            :updatePromo="updatePromo"
            :finishedSection="finishedSection"
            :promo="promo"
            :toggleInfoModal="toggleInfoModal"
            :setSectionIncomplete="setSectionIncomplete"
          />
          <div v-if="promo.id && promo.status !== 'Archived'" class="restore-archive-container">
            <div class="restore-archive-txt">
              {{ activePromoText }}
            </div>
            <button
              type="button"
              class="deactivate-promo"
              @click="togglePopup('showArchivePopup', true)"
            >
              Deactivate promo
            </button>
          </div>
          <div v-else-if="promo.id" class="restore-archive-container">
            <div class="restore-archive-txt">This is an inactive promotion</div>
            <button
              type="button"
              class="activate-promo"
              @click="togglePopup('showRestorePopup', true)"
            >
              Activate promo
            </button>
          </div>
        </div>
        <div class="pb-footer-container">
          <button
            v-if="promo?.id"
            type="button"
            class="pb-footer-button"
            :disabled="
              !finishedSection.includes('promo-images') &&
              !finishedSection.includes('offer-summary')
            "
            @click="
              toggleWarnPopup(
                finishedSection.length < 5 ? 'showMemberDraftWarnPopup' : 'showMemberWarnPopup',
                true,
                () => savePromo(),
              )
            "
          >
            Save
            {{ finishedSection.length < 5 ? 'as Draft' : '' }}
            and Exit
          </button>
          <button
            v-else
            type="button"
            class="pb-footer-button"
            :disabled="
              !finishedSection.includes('promo-images') &&
              !finishedSection.includes('offer-summary')
            "
            @click="
              toggleWarnPopup(
                finishedSection.length < 5 ? 'showMemberDraftWarnPopup' : 'showMemberWarnPopup',
                true,
                () => createNewPromo(true),
              )
            "
          >
            Save
            {{ finishedSection.length < 5 ? 'as Draft' : '' }}
            and Exit
          </button>
          <button
            v-if="promo?.id && isSmacAdmin"
            type="button"
            class="pb-footer-button red"
            @click="togglePopup('showDeletePopup', true)"
          >
            Delete Promo
          </button>
          <button
            v-else-if="!promo?.id"
            type="button"
            class="pb-footer-button"
            :disabled="finishedSection.length !== 5"
            @click="
              toggleWarnPopup(
                finishedSection.length < 5 ? 'showMemberDraftWarnPopup' : 'showMemberWarnPopup',
                true,
                () => createNewPromo(false),
              )
            "
          >
            Save and Add New Promo
          </button>
        </div>
      </div>
      <div class="flex-row-1 align-start just-center">
        <PreviewOne
          :promo="promo"
          :partnerSettings="partnerSettings"
          :currentCorporation="currentCorporation"
          :imagePreviewOne="imagePreviewOne"
        />
        <PreviewTwo
          :promo="promo"
          :previewLabelsVisible="previewLabelsVisible"
          :partnerSettings="partnerSettings"
          :currentCorporation="currentCorporation"
          :imagePreviewOne="imagePreviewOne"
          :imagePreviewTwo="imagePreviewTwo"
        />
      </div>
    </div>
    <ConfirmExitPopup
      :show="showExitPopup"
      :close="() => togglePopup('showExitPopup', false)"
      :exit="close"
    />
    <MemberWarningPopup
      :show="showMemberWarnPopup"
      :close="() => togglePopup('showMemberWarnPopup', false)"
      :addPromo="handleNewPromo"
    />
    <ConfirmDeletePopup
      :show="showDeletePopup"
      :close="() => togglePopup('showDeletePopup', false)"
      :deletePromo="deletePromo"
    />
    <ConfirmArchivePopup
      :show="showArchivePopup"
      :close="() => togglePopup('showArchivePopup', false)"
      :archivePromo="archivePromo"
    />
    <ConfirmRestorePopup
      :show="showRestorePopup"
      :close="() => togglePopup('showRestorePopup', false)"
      :restorePromo="restorePromo"
    />
    <InfoModal :show="showInfoModal" :close="() => (showInfoModal = false)" :view="infoModalView" />
    <MemberDraftWarningPopup
      :show="showMemberDraftWarnPopup"
      :close="() => (showMemberDraftWarnPopup = false)"
      :addPromo="handleNewPromo"
    />
    <ProcessOverlay :show="savingPromo" />
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';

import ProcessOverlay from '@shared/components/ProcessOverlay.vue';
import OfferSummary from '@shared/components/promo/OfferSummary.vue';
import OfferType from '@shared/components/promo/OfferType.vue';
import PromoImages from '@shared/components/promo/PromoImages.vue';
import PromoDetailsImage from '@shared/components/promo/PromoDetailsImage.vue';
import PromotionInfo from '@shared/components/promo/PromotionInfo.vue';
import PreviewOne from '@shared/components/promo/PreviewOne.vue';
import PreviewTwo from '@shared/components/promo/PreviewTwo.vue';
import ConfirmExitPopup from '@shared/components/partnerSettings/providerPlan/ConfirmExitPopup.vue';
import MemberWarningPopup from '@shared/components/partnerSettings/providerPlan/MemberWarningPopup.vue';
import ConfirmDeletePopup from '@shared/components/promo/modal/ConfirmDeletePopup.vue';
import ConfirmArchivePopup from '@shared/components/promo/modal/ConfirmArchivePopup.vue';
import ConfirmRestorePopup from '@shared/components/promo/modal/ConfirmRestorePopup.vue';
import MemberDraftWarningPopup from './MemberDraftWarningPopup.vue';
import InfoModal from '../InfoModal.vue';

export default {
  name: 'PromoBuilder',
  components: {
    OfferSummary,
    OfferType,
    PromoImages,
    PromoDetailsImage,
    PromotionInfo,
    PreviewOne,
    PreviewTwo,
    ConfirmExitPopup,
    MemberWarningPopup,
    ConfirmDeletePopup,
    ConfirmArchivePopup,
    ConfirmRestorePopup,
    MemberDraftWarningPopup,
    ProcessOverlay,
    InfoModal,
  },
  props: {
    selectedPromo: Object,
    currentCorporation: Object,
    partnerSettings: Object,
    close: Function,
  },
  data() {
    return {
      promo: {
        id: null,
        title: '',
        subTitle: '',
        actionText: '',
        actionUri: '',
        cardTitle: '',
        promoName: '',
        description: '',
        startDate: new Date(),
        endDate: moment().add(1, 'days').toDate(),
        sendTime: '12:00',
        sendPush: false,
        sendEmail: false,
        sendTimezone: '',
        actionType: 'URL',
        plans: [],
        showExpiration: true,
      },
      activeStepIdx: 1,
      imagePreviewOne: '',
      imagePreviewTwo: '',
      previewOneFile: null,
      previewTwoFile: null,
      showExitPopup: false,
      showDeletePopup: false,
      showArchivePopup: false,
      showRestorePopup: false,
      showMemberWarnPopup: false,
      savingPromo: false,
      showMemberDraftWarnPopup: false,
      showInfoModal: false,
      infoModalView: '',
      previewLabelsVisible: true,
      finishedSection: [],
      errorObj: {},
      actionToPerform: '',
    };
  },
  computed: {
    ...mapGetters(['isSmacAdmin']),
    activePromoText() {
      if (moment().isBefore(this.promo.startDate)) {
        return `This promo starts on ${moment(this.promo.startDate).format('MMM Do, YYYY')}`;
      }
      if (moment().isAfter(this.promo.endDate)) {
        return `This promo ended on ${moment(this.promo.endDate).format('MMM Do, YYYY')}`;
      }
      return 'This is an active promotion';
    },
  },
  mounted() {
    this.handleMounted();
  },
  methods: {
    async handleNewPromo() {
      await this.togglePopup('showMemberWarnPopup', false);
      await this.actionToPerform();
    },
    async handleMounted() {
      if (this.selectedPromo?.id) {
        this.finishedSection = [
          'offer-summary',
          'promo-images',
          'promo-detail-image',
          'offer-type',
          'promo-info',
        ];
        this.promo = {
          ...this.selectedPromo,
        };
        if (this.promo.backgroundUri) {
          this.imagePreviewOne = this.promo.backgroundUri;
        }
        if (this.promo.mainImageUri) {
          this.imagePreviewTwo = this.promo.mainImageUri;
        }
      }
    },
    toggleInfoModal(show, view) {
      this.showInfoModal = show;
      this.infoModalView = view;
    },
    changeActiveStepIdx(idx) {
      this.activeStepIdx = idx;
    },
    setSectionIncomplete(section) {
      const idx = this.finishedSection.indexOf(section);
      if (idx >= 0) {
        const newFinished = this.finishedSection.slice();
        newFinished.splice(idx, 1);
        this.finishedSection = newFinished;
      }
    },
    updatePromo(newPromo, section) {
      this.promo = newPromo;
      if (!this.finishedSection.includes(section)) {
        this.finishedSection = [...this.finishedSection, section];
      }
    },
    base64ToFile(base64, filename = 'image.png') {
      const arr = base64.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },
    changeSelectedImage(imageName, image) {
      if (image) {
        this.imagePreviewOne = image;
        this.previewOneFile = image.startsWith('data:image')
          ? this.base64ToFile(image, imageName)
          : {
              name: image.split(
                'https://smartac-promo-prod.s3.us-west-2.amazonaws.com/default/',
              )[1],
              uri: image,
            };
      } else {
        this.imagePreviewOne = null;
        this.previewOneFile = null;
      }
    },
    changeSelectedDetailImage(imageName, image) {
      if (image) {
        this.imagePreviewTwo = image;
        this.previewTwoFile = image.startsWith('data:image')
          ? this.base64ToFile(image, imageName)
          : {
              name: image.split(
                'https://smartac-promo-prod.s3.us-west-2.amazonaws.com/defaultDetails/',
              )[1],
              uri: image,
            };
      } else {
        this.imagePreviewTwo = null;
        this.previewTwoFile = null;
      }
    },
    async savePromo() {
      try {
        this.savingPromo = true;
        await this.$store.dispatch('updatePromo', {
          promo: {
            ...this.promo,
            status:
              this.finishedSection.length === 5 && this.promo.status === 'Draft'
                ? 'Created'
                : this.promo.status,
            showText: this.previewLabelsVisible,
            backgroundUri: this.previewOneFile?.uri ?? this.promo?.backgroundUri,
            mainImageUri: this.previewTwoFile?.uri ?? this.promo?.mainImageUri,
            corpId: this.currentCorporation.id,
            endDate: this.promo.active ? new Date('2100-01-01') : this.promo.endDate,
          },
          backgroundImage: this.previewOneFile?.uri ? null : this.previewOneFile,
          backgroundImageName: this.previewOneFile?.uri ? null : this.previewOneFile?.name,
          mainImage: this.previewTwoFile?.uri ? null : this.previewTwoFile,
          mainImageName: this.previewTwoFile?.uri ? null : this.previewTwoFile?.name,
        });
        this.close();
        this.$store.dispatch('showSuccessToast', {
          message: 'Success! Your promo was saved.',
        });
      } catch (err) {
        this.$store.dispatch('showAlertToast', {
          message:
            'There was an unexpected error while updating this promo. Please try again or contact support',
        });
      }
      this.savingPromo = false;
    },
    async createNewPromo(closeModal) {
      try {
        this.savingPromo = true;
        await this.$store.dispatch('createPromo', {
          promo: {
            ...this.promo,
            status: this.finishedSection.length < 5 ? 'Draft' : 'Created',
            showText: this.previewLabelsVisible,
            backgroundUri: this.previewOneFile?.uri ?? null,
            mainImageUri: this.previewTwoFile?.uri ?? null,
            corpId: this.currentCorporation.id,
            endDate: this.promo.active ? new Date('2100-01-01') : this.promo.endDate,
          },
          backgroundImage: this.previewOneFile?.uri ? null : this.previewOneFile,
          backgroundImageName: this.previewOneFile?.uri ? null : this.previewOneFile?.name,
          mainImage: this.previewTwoFile?.uri ? null : this.previewTwoFile,
          mainImageName: this.previewTwoFile?.uri ? null : this.previewTwoFile?.name,
        });
        this.$store.dispatch('showSuccessToast', {
          message: 'Success! Your promo was saved.',
        });
        if (closeModal) {
          this.close();
        } else {
          this.activeStepIdx = 1;
          this.promo = {
            title: '',
            subTitle: '',
            actionText: '',
            actionUri: '',
            cardTitle: '',
            promoName: '',
            description: '',
            startDate: '',
            endDate: '',
            sendTime: '',
            sendPush: true,
            sendEmail: true,
            sendTimezone: '',
            actionType: '',
            phoneNumber: '',
            showExpiration: true,
          };
          this.imagePreviewOne = '';
          this.imagePreviewTwo = '';
          this.previewOneFile = null;
          this.previewTwoFile = null;
          this.finishedSection = [];
        }
      } catch (err) {
        this.$store.dispatch('showAlertToast', {
          message:
            'There was an unexpected error while creating this promo. Please try again or contact support',
        });
      }
      this.savingPromo = false;
    },
    async deletePromo() {
      this.savingPromo = true;
      try {
        await this.$store.dispatch('deletePromo', this.promo.id);
        this.$store.dispatch('showSuccessToast', {
          message: 'Promo was successfully deleted',
        });
        this.close();
      } catch (err) {
        this.$store.dispatch('showAlertToast', {
          message:
            'There was an unexpected error while deleting this promo. Please try again or contact support',
        });
      }
      this.savingPromo = false;
    },
    async archivePromo() {
      try {
        this.savingPromo = true;
        await this.$store.dispatch('updatePromo', {
          promo: {
            ...this.promo,
            status: 'Archived',
          },
        });
        this.close();
        this.$store.dispatch('showSuccessToast', {
          message: 'Success! Your promo was archived.',
        });
      } catch (err) {
        this.$store.dispatch('showAlertToast', {
          message:
            'There was an unexpected error while archiving this promo. Please try again or contact support',
        });
      }
      this.savingPromo = false;
    },
    async restorePromo() {
      try {
        this.savingPromo = true;
        await this.$store.dispatch('updatePromo', {
          promo: {
            ...this.promo,
            status: 'Created',
          },
        });
        this.close();
        this.$store.dispatch('showSuccessToast', {
          message: 'Success! Your promo was restored.',
        });
      } catch (err) {
        this.$store.dispatch('showAlertToast', {
          message:
            'There was an unexpected error while restoring this promo. Please try again or contact support',
        });
      }
      this.savingPromo = false;
    },
    togglePopup(field, show) {
      this[field] = show;
    },
    toggleWarnPopup(field, show, action) {
      this[field] = show;
      this.actionToPerform = action;
    },
    changePreviewLabelsVisible(val) {
      this.previewLabelsVisible = val;
    },
  },
};
</script>

<style lang="scss">
.pb-card-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: Poppins;

  @media (min-width: 1700px) {
    font-size: 120%;
  }

  .pb-top-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 63px;
    padding: 0 30px;
    background-color: #e0e8ff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.08);

    .pb-header-container {
      display: flex;
      align-items: center;

      .logo {
        width: 35px;
        margin-right: 24px;
      }

      .pb-header {
        font-size: 1.25em;
        font-weight: 500;
        color: $NAVY100;
      }
    }

    .close-button {
      width: 28px;
      height: 28px;
      border-radius: 4px;
      background-color: $N5;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.08);
      display: flex;
      align-items: center;
      justify-content: center;

      .close-img {
        width: 10px;
        height: 10px;
      }
    }
  }

  .pb-body-container {
    flex: 1;
    width: 100%;
    height: 100%;
    display: flex;
    overflow-y: auto;

    .pb-section-container {
      display: flex;
      flex-direction: column;
      flex: 1;
      height: 100%;
      overflow-y: auto;
      position: relative;

      .pb-section-body-container {
        padding: 24px 73px 100px 61px;
        flex: 1;

        .pb-logo-container {
          height: 80px;
          width: 80px;
          border-radius: 6px;
          padding: 4px;
          margin-bottom: 17px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: auto;
          margin-right: auto;

          .pb-logo {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      }

      .pb-footer-container {
        position: sticky;
        bottom: 0;
        left: 0;
        right: 0;
        min-height: 74px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: $WHITE;
        border-top: 1px solid $N5;

        .pb-footer-button {
          width: 175px;
          height: 24px;
          font-size: 0.625em;
          color: $WHITE;
          background-color: $NBLUE100;
          border-radius: 6px;

          &[disabled] {
            background-color: $N40;
          }

          &:first-child {
            margin-right: 28px;
          }

          @media (min-width: 1700px) {
            width: 180px;
            height: 36px;
          }
        }
      }
    }

    .flex-row-1 {
      padding-top: 24px;
      background-image: url('@shared/assets/img/setting/plan-popup-bg.png');
      background-size: 100% 100%;
    }

    .restore-archive-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-top: 15px;

      .restore-archive-txt {
        font-size: 0.75em;
        font-weight: 500;
        color: $N100;
      }

      .deactivate-promo {
        font-size: 0.75em;
        font-weight: 500;
        color: #ef5b52;
        text-decoration: underline;
      }

      .activate-promo {
        font-size: 0.75em;
        font-weight: 500;
        color: #4979ff;
        text-decoration: underline;
      }
    }
  }
}
</style>
